<h2 class="re-mb-30 md:re-mb-60">
  <span class="line"></span>
  <ng-content></ng-content>
</h2>
